import { useI18n } from '@cascade/react/i18n';
import { Button, Text } from '@cascade/ui-library';
import { useCountdown } from '@cascade/react/hooks';
import classes from './MagicLinkSent.module.scss';
import type { TMagicLinkSentProps } from './MagicLinkSent.types.ts';

export const MagicLinkSent = ({
  email,
  canResendAt,
  onResend,
}: TMagicLinkSentProps) => {
  const { translate } = useI18n();
  const secondsLeft = useCountdown(canResendAt);

  const canResend = secondsLeft === 0;

  return (
    <div className={classes['magic-link-sent']}>
      <div className={classes.paragraphs}>
        <Text
          type='body-2'
          content={translate('signIn.magicLink.sent', { email })}
        />
        <Text type='body-2' content={translate('signIn.magicLink.checkSpam')} />
        <Text type='body-2' content={translate('signIn.magicLink.expiry')} />
      </div>
      <Button
        variant='secondary'
        label={
          canResend
            ? translate('signIn.magicLink.resend')
            : translate('signIn.magicLink.resendIn', { seconds: secondsLeft })
        }
        disabled={!canResend}
        onClick={onResend}
      />
    </div>
  );
};
